import { cva } from 'cva';
export const textareaVariants = cva({
    base: [
        '@flex',
        '@px-2',
        '@py-1.5',
        '@rounded',
        '@border',
        '@border-grey-2_5',
        '@bg-grey-2-a',
        'data-[state=error]:@border-red1-1',
        'data-[state=focus]:@border-brand1-1',
        'data-[state=disabled]:@bg-grey-2',
    ],
    variants: {
        counter: {
            true: ['@flex-col', '@space-y-0.5'],
            false: [],
        },
    },
    defaultVariants: { counter: false },
});
export const textareaClassNames = [
    '@text-b2',
    '@text-grey-6',
    '@flex-auto',
    '@min-w-0',
    '@outline-none',
    '@bg-transparent',
    'data-[state=disabled]:@cursor-not-allowed',
    'data-[state=disabled]:@text-grey-4',
];
export const textareaErrorContainerClassNames = [
    '@mt-0.5',
];
export const textareaErrorClassNames = [
    '@text-red1-1',
    '@text-caption',
    '@flex',
    '@items-center',
    '@space-x-0.5',
];
export const textareaErrorIconClassNames = [
    '@w-3.5',
    '@h-3.5',
    '@mr-0.5',
];
export const textareaCounterClassNames = [
    '@text-right',
    '@text-num12',
    '@text-grey-4',
];
export const textareaCounterAmountClassNames = [
    '@text-grey-6',
];
